export default "__VITE_ASSET__DHCxGeNT__"